export default "__VITE_ASSET__710af580__"